// extracted by mini-css-extract-plugin
module.exports = {"body":"TextAddStable_body__1nnOA"};